/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "CreatePortfolioPageService";
const log: any = LoggerModule.getInstance();

export class CreatePortfolioPageService {
    private static instance: CreatePortfolioPageService;
    private vapp: VApplication;
    private formData: any = [];
    private credentialForm: any = [];
    private evidenceKanbanList: any = [];
    private createPortfolio: any = {};
    private credentials:any = [];
    private constructor(props: any = {}) {
      this.vapp = VApplication.getInstance();
    }
  
    public static getInstance(
      props: any = {}
    ): CreatePortfolioPageService {
      if (!CreatePortfolioPageService.instance) {
        CreatePortfolioPageService.instance =
          new CreatePortfolioPageService(props);
      }
      return CreatePortfolioPageService.instance;
    }

    public resetFormData(){
      this.formData = [];
    }

    public setFormData(args: any) {
      console.log(`args in set form data`, args);
      let _found = false;
      let tempFormData: any = this.formData;
        this.formData.forEach((element: any, index: number) => {
          if (element?.id === args?.id) {
            tempFormData[index] = {...element, ...args?.formData}
            _found = true;
          }
        });
      if(_found === false) {
        console.log(`found or not found`, _found);
        tempFormData.push({
          ...args?.formData,
        id:args?.id});
      }
      console.log(`set form data value`, tempFormData);
  
      this.formData = tempFormData;
    }
  
    public async getPageContent(args:any) {
      let content: any = {};
      let compProps: any = null;
      const agent = getAgent();

      //List of Credentials 
      const _args = {
        submit:false
      }

      let credProps = await agent.getSubmitPortfolio(_args);
      console.log('credentials', credProps);
      if(credProps){
        this.credentials = credProps?.credentials;
        content = { ...content, credentials:credProps?.credentials};
      }
      
      //Template Form
      compProps = await agent.getPortfolioFormProps(args);
      if (compProps) {
        this.credentialForm = compProps;
        content = { ...content, ...compProps };
      }
  
    //   //Evidence Kanban Props
    //   compProps = await agent.getEvidenceKanbanProps({});
    //   if (compProps) {
    //     content = { ...content, ...compProps };
    //     this.evidenceKanbanList = compProps.evidenceKanbanList;
    //   }
  
    //   //CreateTemplate Props
    //   compProps = await agent.getCreateTemplateProps({});
    //   if (compProps) {
    //     content = { ...content, ...compProps, ...this.createPortfolio };
    //   }
  
      return content;
    }
  
    public getStaticPageContent() {
      let content: any = {};
      let compProps: any = null;
      const agent = getAgent();
  
      compProps = agent.getStaticPageContentSync({});
      if (compProps) {
        content = { ...content, ...compProps };
      }
  
      return content;
    }

    public async submitCredentialForm(args: any) {
      this.setFormData(args);
      let _cred = Array.isArray(this.credentials) && this.credentials?.find(ele=> ele?.schemaRef=== args?.id);
        console.log(`formdata in service`, args);
        let _args = {
          ...args,
          id:_cred?.id
        }
      const agent = getAgent();
      return agent.getSavePortfolio(_args);
    }
  
    public submitForReview(){
      const agent = getAgent();
      const _args = {
        submit:true
      };
      return agent.getSubmitPortfolio(_args);
    }

    public getFormDefaultData(){
        console.log(`default data`, this.formData);
        const agent = getAgent();
        let formProps:any = {};
        let _args = {
          formData:this.formData,
          credentialForm: this.credentialForm
        }
       formProps = agent.getPortfolioPreviewContentSync(_args);
       return formProps;
    }

    public getDefaultData(){
      console.log(`default data`, this.formData);
      return this.formData;
    }

    // public async initiateDraft(){
    //   const agent = getAgent();
    //   const _args = {
    //     submit:false
    //   };
    //   return await agent.getSubmitPortfolio(_args);
    // }

  }